// extracted by mini-css-extract-plugin
module.exports = {"sharedStyles":"\"../../themes/sharedStyles.module.css\"","caption":"Caption_caption__4Jtkh sharedStyles_standardTextStructure__2HVr-"};